import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const stack = [{
  label: '📘 Mechanics Decision Map™ — 6 Premium Volumes',
  value: '$97'
}, {
  label: '🎁 5 Professional Bonuses',
  value: '$197'
}];
export function Offer() {
  return <section className="bg-navy-950 py-14 sm:py-20" data-id="element-194" data-mp="3549h6km63pgu">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-195" data-mp="3a4dygcuwgo84">
        <div className="text-center" data-id="element-196" data-mp="3f4jt81wguquf">
          <span className="inline-block rounded-full bg-sky-600 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-white sm:text-xs" data-id="element-197" data-mp="3f3i4wvqfw7ur">
            🏆 Special launch offer
          </span>
          <h2 className="mt-5 font-display text-[27px] font-bold leading-tight text-white sm:text-4xl" data-id="element-198" data-mp="3nvsj0o4ggxha">
            Here’s everything you’ll receive today
          </h2>
        </div>

        <div className="mt-8 rounded-2xl bg-white p-5 sm:p-8" data-id="element-199" data-mp="1ou93oxcnpyc">
          <ul className="divide-y divide-navy-900/10" data-id="element-200" data-mp="1nau01nfjky5">
            {stack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-201" data-mp="1kj3vjkiwsxw9">
                <span className="text-[14.5px] font-semibold leading-snug text-navy-900 sm:text-base" data-id="element-202" data-mp="1fohqs07c23l5">
                  {item.label}
                </span>
                <span className="shrink-0 text-[14.5px] font-bold text-navy-800/60 line-through sm:text-base" data-id="element-203" data-mp="16mqol5c04ew1">
                  {item.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 py-3.5" data-id="element-204" data-mp="1zbfj2lijxlyt">
              <span className="text-[13px] font-extrabold uppercase tracking-[0.1em] text-navy-900" data-id="element-205" data-mp="1uj4gfawffm2k">
                Total value
              </span>
              <span className="text-lg font-extrabold text-navy-800/60 line-through" data-id="element-206" data-mp="1pkb43lsvm13z">$294</span>
            </li>
          </ul>

          <div className="mt-5 rounded-2xl bg-cream px-5 py-6 text-center" data-id="element-207" data-mp="2i98k1i9m7ltk">
            <p className="text-[12px] font-extrabold uppercase tracking-[0.12em] text-navy-800/70" data-id="element-208" data-mp="2i75ko7mkogc6">
              Today you get everything for just
            </p>
            <p className="mt-2 font-display text-[64px] font-bold leading-none text-navy-900 sm:text-7xl" data-id="element-209" data-mp="363ip4v2ihp7m">
              $27
            </p>
            <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[12.5px] font-semibold text-navy-800/80 sm:text-sm" data-id="element-210" data-mp="2sb2scc07enf5">
              <li data-id="element-211" data-mp="2idy3u5ivyfv6">One-time payment</li>
              <li aria-hidden="true" data-id="element-212" data-mp="2ih2ftp2lefwe">·</li>
              <li data-id="element-213" data-mp="2nelugq37cuov">Lifetime access</li>
              <li aria-hidden="true" data-id="element-214" data-mp="2nfnhlsxht7my">·</li>
              <li data-id="element-215" data-mp="29eb3ln1w7g3p">No monthly fees</li>
              <li aria-hidden="true" data-id="element-216" data-mp="29fcoej8pngym">·</li>
              <li data-id="element-217" data-mp="29gnskk62iqq9">Instant digital access</li>
            </ul>
          </div>

          <p className="mt-5 text-center text-[14.5px] leading-relaxed text-navy-800/80 sm:text-[15px]" data-id="element-218" data-mp="2dgenn02mnt0l">
            For less than the cost of a typical meal, you’ll have a visual biomechanical decision system to
            structure your analysis whenever you face a complex mechanic.
          </p>

          <div className="mt-6" data-id="element-219" data-mp="1w6u0ytojs8rz">
            <CTAButton size="large" label="Yes — I want Mechanics Decision Map™" subline="One-time payment of $27 · Instant access · Lifetime access · 7-day guarantee" data-id="element-220" data-mp="1s4z35z5tsdiy" />
          </div>

          <p className="mt-4 flex items-center justify-center gap-2 rounded-xl bg-sand px-4 py-3 text-center text-[12.5px] font-medium leading-snug text-navy-800/80 sm:text-sm" data-id="element-221" data-mp="214m1ud76758b">
            <GlobeIcon className="h-4 w-4 shrink-0 text-sky-600" aria-hidden="true" data-id="element-222" data-mp="2avzymd7qlqxr" />
            Currency conversion is automatic — you pay in your local currency.
          </p>
        </div>

        <div className="mt-6" data-id="element-223" data-mp="2jvn0f04doyrc">
          <ScarcityBar tone="dark" data-id="element-224" data-mp="2jxg9em2grv2i" />
        </div>

        <div className="mt-8" data-id="element-225" data-mp="uh8h4vc4q438">
          <Countdown tone="dark" data-id="element-226" data-mp="ugf8fotm14ig" />
        </div>
      </div>
    </section>;
}